import { Colors, DropdownListItem, FInter, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "core";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { ProjectCardTitle } from "shared/components/projectCard/styles";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css } from "styled-components";
import { Skeleton } from "@brg/ui"
import { DesignerMultipleAuthors } from "shared/components/projectDesignerName/styles";

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;



export const EmblemImgContainer = styled(FlexBox)<{ imgShowed?: boolean, isSuperPuper?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    min-width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin: -20px 0 0 24px;

    .empty-holder {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      margin-top: 0;
      width: 220px;
      height: 310px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-left: 16px;
        min-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        max-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        height: 489px;
        max-height: 489px;
      //width: 166px;
      //height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }
    ${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.m}px) {
          top: -150px !important;
          margin-bottom: -150px;
        }
    `}
      
`;

export const WideContainer = styled(FlexBox)<{ isLoading?: boolean }>`
  position: relative;
  margin-top: 16px;
  margin-bottom: 24px;
  // cursor: pointer;
  width: 100%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  width: ${LayoutConst.container.l}px;
  max-width: ${LayoutConst.container.l}px;
  min-width: ${LayoutConst.container.l}px;
  height: auto;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.container.m}px;
      max-width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      // max-height: 234px;
      width: ${LayoutConst.container.xs}px;
      max-width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-top: 0;
    }
`;

export const CoverImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: 0;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
`;

export const TitleBox = styled(FlexBox)`
  position: absolute;
  z-index: 2;
  flex-flow: column;
  bottom: 24px;
  background-color: #f2f2f2;
  min-height: 116px;
  padding: 16px 24px;
  left: 0;
  width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  max-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  min-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  justify-content: space-between;

  .multiple-authors {
    :hover {
      color: #151514;
    }
  }

  ${DesignerMultipleAuthors} {
    :hover {
      .item {
        z-index: 99999;
      }

      color: #151514;
      .multiple-authors {
        color: #151514;
      }
      svg path {
        fill: #151514;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 82px;
  }
`;


export const Title = styled(ProjectCardTitle)`
  font-size: 22px;
  line-height: 28px;
  color: ${({ theme }) => theme.wideCover.info.title.color};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }

`;

export const Author = styled(FlexBox)`
  color: ${({ theme }) => theme.wideCover.info.author.color};
  font-size: 13px;
  line-height: 16px;
`;

export const ImageCover = styled(FlexBox)`
  margin: 0 auto;
  width: 534px;
  height: 240px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 355px;
    height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    max-width: 320px;
    height: auto;
  }
`;


export const LettersAvatarWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 90px !important;
  color: ${Colors.geoWhite47} !important;
  border-radius: initial;
`;

export const TeamTabsWrapper = styled(FlexBox)`
  &:empty {
    display: none;
  }
`;

export const ChannelNamContainer = styled.div<{ bg: string }>`
  position: static;
  width: 100%;
  height: 100%;
  flex-flow: column;
  display: flex;
  padding: 24px;
  background-color: ${({ bg }) => bg ? bg : '#909090'};

  .course-lms_type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 4px;
    color: #fff;
  }

  .course-type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 10px;
    color: #fff;
  }

  .course-name {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #fff;
    margin-bottom: 16px;
  }

`;

export const SubTitleGroupName = styled.div`
   font-family: 'Inter';
    font-weight: 600;
    font-size: 23px;
    line-height: 27px;
    letter-spacing: -2%;
    color: #151514;
    margin-top: 8px;
`;import { Colors, DropdownListItem, FInter, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "core";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { ProjectCardTitle } from "shared/components/projectCard/styles";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css } from "styled-components";
import { Skeleton } from "@brg/ui"
import { DesignerMultipleAuthors } from "shared/components/projectDesignerName/styles";

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;



export const EmblemImgContainer = styled(FlexBox)<{ imgShowed?: boolean, isSuperPuper?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    min-width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin: -20px 0 0 24px;

    .empty-holder {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      margin-top: 0;
      width: 220px;
      height: 310px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-left: 16px;
        min-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        max-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        height: 489px;
        max-height: 489px;
      //width: 166px;
      //height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }
    ${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.m}px) {
          top: -150px !important;
          margin-bottom: -150px;
        }
    `}
      
`;

export const WideContainer = styled(FlexBox)<{ isLoading?: boolean }>`
  position: relative;
  margin-top: 16px;
  margin-bottom: 24px;
  // cursor: pointer;
  width: 100%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  width: ${LayoutConst.container.l}px;
  max-width: ${LayoutConst.container.l}px;
  min-width: ${LayoutConst.container.l}px;
  height: auto;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.container.m}px;
      max-width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      // max-height: 234px;
      width: ${LayoutConst.container.xs}px;
      max-width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-top: 0;
    }
`;

export const CoverImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: 0;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
`;

export const TitleBox = styled(FlexBox)`
  position: absolute;
  z-index: 2;
  flex-flow: column;
  bottom: 24px;
  background-color: #f2f2f2;
  min-height: 116px;
  padding: 16px 24px;
  left: 0;
  width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  max-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  min-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  justify-content: space-between;

  .multiple-authors {
    :hover {
      color: #151514;
    }
  }

  ${DesignerMultipleAuthors} {
    :hover {
      .item {
        z-index: 99999;
      }

      color: #151514;
      .multiple-authors {
        color: #151514;
      }
      svg path {
        fill: #151514;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 82px;
  }
`;


export const Title = styled(ProjectCardTitle)`
  font-size: 22px;
  line-height: 28px;
  color: ${({ theme }) => theme.wideCover.info.title.color};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }

`;

export const Author = styled(FlexBox)`
  color: ${({ theme }) => theme.wideCover.info.author.color};
  font-size: 13px;
  line-height: 16px;
`;

export const ImageCover = styled(FlexBox)`
  margin: 0 auto;
  width: 534px;
  height: 240px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 355px;
    height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    max-width: 320px;
    height: auto;
  }
`;


export const LettersAvatarWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 90px !important;
  color: ${Colors.geoWhite47} !important;
  border-radius: initial;
`;

export const TeamTabsWrapper = styled(FlexBox)`
  &:empty {
    display: none;
  }
`;

export const ChannelNamContainer = styled.div<{ bg: string }>`
  position: static;
  width: 100%;
  height: 100%;
  flex-flow: column;
  display: flex;
  padding: 24px;
  background-color: ${({ bg }) => bg ? bg : '#909090'};

  .course-lms_type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 4px;
    color: #fff;
  }

  .course-type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 10px;
    color: #fff;
  }

  .course-name {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #fff;
    margin-bottom: 16px;
  }

`;

export const SubTitleGroupName = styled.div`
   font-family: 'Inter';
    font-weight: 600;
    font-size: 23px;
    line-height: 27px;
    letter-spacing: -2%;
    color: #151514;
    margin-top: 8px;
`;